import { Spinner } from 'common/Spinner/Spinner'

import Styles from './HandbookSpinner.module.scss'

export const HandbookSpinner = () => {
  return (
    <div className={Styles.loadingWrapper}>
      <Spinner />
    </div>
  )
}
